class NovaPriceRange extends HTMLElement {
  constructor() {
    super()

    this.$filterWrapper = document.querySelector('nova-filters-wrapper')
    this.$priceBar = document.querySelector('.js-filter-price-bar')
    const $inputs = this.querySelectorAll('sl-input')
    for (const $input of $inputs) {
      $input.addEventListener('sl-change', this.onRangeChange)
    }

    this.setMinAndMaxValues()
  }

  onRangeChange = (event) => {
    this.adjustToValidValues(event.currentTarget)
    this.setMinAndMaxValues()
    this.$filterWrapper.debouncedOnSubmit(event)
  }

  setMinAndMaxValues() {
    const $inputs = this.querySelectorAll('sl-input')
    const $minInput = $inputs[0]
    const $maxInput = $inputs[1]
    const maxValue = $maxInput.getAttribute('max')
    let maxOffset = 0
    let minOffset = 0
    if ($maxInput.value) {
      $minInput.setAttribute('max', $maxInput.value)
      maxOffset = (maxValue - $maxInput.value) / maxValue * 100
    }
    if ($minInput.value) {
      $maxInput.setAttribute('min', $minInput.value)
      minOffset = ($minInput.value / maxValue) * 100
    }
    if ($minInput.value === '') $maxInput.setAttribute('min', 0)
    if ($maxInput.value === '')
      $minInput.setAttribute('max', $maxInput.getAttribute('max'))
    
    this.$priceBar.style.setProperty(
      '--max-value',
      `${maxOffset}%`,
    )
    this.$priceBar.style.setProperty(
      '--min-value',
      `${minOffset}%`,
    )
  }

  adjustToValidValues(input) {
    const value = Number(input.value)
    const min = Number(input.getAttribute('min'))
    const max = Number(input.getAttribute('max'))

    if (value < min) input.value = min
    if (value > max) input.value = max
  }
}

customElements.define('nova-price-range', NovaPriceRange)
